const quagga = {
  locate: true,
  inputStream: {
    name: "live",
    type: "LiveStream",
    target: null,
  },

  decoder: {
    readers: ["ean_reader"],
    multiple: true,
  },
  locator: {
    halfSample: true,
    patchSize: "medium",
  },
};

const jsBarcode = {
  blankSize: 20,
  general: {
    font: "Roboto",
  },
  barcode: {
    fontSize: 18,
    textMargin: 0,
  },
};

export const configs = {
  quagga,
  jsBarcode,
};



// WEBPACK FOOTER //
// ./src/_shared/constants/configs.js